import { render, staticRenderFns } from "./BaseListItemContainer.vue?vue&type=template&id=118a1acc"
import script from "./BaseListItemContainer.vue?vue&type=script&lang=ts"
export * from "./BaseListItemContainer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports